import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
import { apisystemsettingByCode, postChildrenAccountAnonymousLogin } from '@/api';
import { v4 as uuidv4 } from 'uuid';
import Fingerprint2 from 'fingerprintjs2';
import store from '@/store';
var browserId = uuidv4();
if (window.requestIdleCallback) {
  requestIdleCallback(function () {
    createFingerprint();
  });
} else {
  setTimeout(function () {
    createFingerprint();
  }, 500);
}
function createFingerprint() {
  Fingerprint2.get(function (components) {
    // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
    var values = components.map(function (component) {
      return component.value;
    }); // 配置的值的数组
    var murmur = Fingerprint2.x64hash128(values.join(''), 31); // 生成浏览器指纹
    localStorage.setItem('browserId', murmur); // 存储浏览器指纹，在项目中用于校验用户身份和埋点
    browserId = murmur;
  });
}
function anoymousUUID() {
  return epId() + browserId;
}
function epId() {
  if (process.env.NODE_ENV === 'development') return '4a57908632c748b1';
  var normalUrl = location.href.includes('children/account');
  var code = normalUrl ? window.location.href.match(/\w+(?=\/index)/g)[0] : window.location.href.match(/zhongyifu\.cn\/(\w+)/) ? window.location.href.match(/zhongyifu\.cn\/(\w+)/)[1] : '';
  return store.state.globalStore.user.epCode || code;
}
export function anonymousLogin() {
  return _anonymousLogin.apply(this, arguments);
}
function _anonymousLogin() {
  _anonymousLogin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var anoymousLogin;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            anoymousLogin = 0;
            _context.next = 3;
            return apisystemsettingByCode({
              code: '40021'
            }).then(function (res) {
              if (res.success && res.data) {
                anoymousLogin = +res.data.value;
              }
            });
          case 3:
            if (!anoymousLogin) {
              _context.next = 9;
              break;
            }
            _context.next = 6;
            return postChildrenAccountAnonymousLogin({
              anonymous_id: anoymousUUID()
            }).then(function (res) {
              if (res.success) {
                store.commit('globalStore/_Authorization', res.data);
                store.dispatch('globalStore/_ApiSession');
              } else {
                return 0;
              }
            });
          case 6:
            return _context.abrupt("return", 1);
          case 9:
            return _context.abrupt("return", 0);
          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _anonymousLogin.apply(this, arguments);
}